import 'ui-core/plugins/outlinejs/js/outline';

(function () {
    UX.outlinejs.rule =
        'a:focus{outline:0} a::-moz-focus-inner{border:0;} ' +
        'input:focus{outline:0} input::-moz-focus-inner{border:0;}' +
        'button:focus{outline:0}  button::-moz-focus-inner{border:0} [type="submit"]::-moz-focus-inner{border:0}' +
        'select:focus{outline:0}  select::-moz-focus-inner{border:0;}';
})();
